import { Button, Row, Col, Flex, Carousel } from "antd";
import {
  workProcessBannerArrow,
} from "../../../assets";
import { useMediaQuery } from "react-responsive";
import { getStrapiMedia } from "../../../helpers/tranformers";


const Industries = ({content}) => {
  const isMobile = useMediaQuery({ query: "(max-width: 760px)" });

  return (
    <div className="section-content">
      <div data-aos="fade-up" data-aos-duration="700" data-aos-delay="400">
        <div className="about-section-heading mobile-left-padding center-text">
          {content?.Heading}
        </div>
        <div
          className="section-heading center-text mobile-mb-60" //mobile-left-padding
          style={{ color: "#5B3AEE" }}
        >
          {content?.Title}{" "}
        </div>
      </div>
      {!isMobile ? (
        <Row gutter={[16, 16]} justify="center">
          {content?.Card.map((card) => (
            <Col key={card?.id} xs={24} sm={12} md={8} lg={6}>
              <div
                className="industry-card-home "
                style={{ backgroundImage: `url(${getStrapiMedia(card?.Image?.url)})` }}
              >
                <div className="industry-card-background"></div>
                <div className="industry-card-content-home">
                  {isMobile ? (
                    <Flex align="center" justify="center" gap={20}>
                      {" "}
                      <div>
                        {" "}
                        <h3>{card?.Title}</h3>
                        <div className="industry-card-content-sub-heading">{card?.Description}</div>
                      </div>
                      <div style={{ width: "60px", height: "60px" }}>
                        <img
                          src={workProcessBannerArrow}
                          alt="send"
                          className="p-img"
                        />
                      </div>
                    </Flex>
                  ) : (
                    <>
                      <h3>{card?.Title}</h3>
                      <div className="industry-card-content-sub-heading">{card?.Description}</div>
                    </>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <Carousel
          effect="fade"
          autoplay={true}
          autoplaySpeed={2000} 
          slidesToShow={1}
          slidesToScroll={1}
          arrows={true} 
          dots={true} 
          draggable={true} 
          infinite={true}
        >
          {content?.Card.map((card) => (
            <Col key={card.id} xs={24} sm={12} md={8} lg={6} data-aos="fade-up"
            data-aos-duration="700"
            data-aos-delay="400">
              <div
                className="industry-card "
                style={{ backgroundImage: `url(${getStrapiMedia(card?.Image?.url)})` }}
                
              >
                <div className="industry-card-background"></div>
                <div className="industry-card-content" >
                  {isMobile ? (
                    <Flex align="center" justify="center" gap={20}>
                      {" "}
                      <div>
                        {" "}
                        <h3>{card?.Title}</h3>
                        <div className="industry-card-content-sub-heading">{card?.Description}</div>
                      </div>
                    </Flex>
                  ) : (
                    <>
                      <h3>{card?.Title}</h3>
                      <div className="industry-card-content-sub-heading">{card?.Description}</div>
                    </>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Carousel>
      )}
      {/* <Row
        className="mt-30"
        data-aos="fade-up"
        data-aos-duration="400"
        data-aos-delay="100"
      >
        <Button
          className="gradient-outlined-button"
          shape="rounded"
          style={{ margin: "0 auto" }}
        >
          LEARN MORE
        </Button>
      </Row> */}
    </div>
  );
};
export default Industries;
